import { render, staticRenderFns } from "./AddLables.vue?vue&type=template&id=65180121&scoped=true&"
import script from "./AddLables.vue?vue&type=script&lang=js&"
export * from "./AddLables.vue?vue&type=script&lang=js&"
import style0 from "./AddLables.vue?vue&type=style&index=0&id=65180121&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65180121",
  null
  
)

export default component.exports